import React from 'react'
import StagesManager from '../components/StagesManager';
import LoginFirstStep from "./Authentication/LoginFirstStep";
import LoginCodeStep from "./Authentication/LoginCodeStep";
import LoginPasswordStep from "./Authentication/LoginPasswordStep";
import LoginInfoStep from "./Authentication/LoginInfoStep";
import LoginWelcomeStep from "./Authentication/LoginWelcomeStep";
import HttpServices from '../utils/Http.services';
import { addToCard, chooseFontColor, getToken, pathMaker } from '../utils/useful';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../stores/actionsList';
import Responsive from '../components/Responsive';
import CHIntroduction from './CreateHub/CHIntroduction';
import CHSelectType from './CreateHub/CHSelectType';
import CHInfo from './CreateHub/CHInfo';
import CHUsername from './CreateHub/CHUsername';
import CHSuccess from './CreateHub/CHSuccess';
import CHHubInfo from './CreateHub/CHHubInfo';
import CHPricing from './CreateHub/CHPricing';
import CHPricingInfo from './CreateHub/CHPricingInfo';
import CHReview from './CreateApplet/CHReview';
import Header from '../components/header/Header';
import store from '../stores/storeConfig';
import { siteConfig } from '../variables/config';

class CreateHub extends React.Component {
    state = {
        pages: [
            { title: 'Usecases', icon: '', link: 'https://info.yonnect.com/usecases', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },
            { title: 'Utilities', icon: '', link: 'https://info.yonnect.com/utilities', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },
            { title: 'Applets', icon: '', link: 'https://info.yonnect.com/applets', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },
            { title: 'About us', icon: '', link: 'https://info.yonnect.com/aboutus', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },
            { title: 'Academy', icon: '', link: 'https://info.yonnect.com/Academy', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },
            { title: 'Newsroom', icon: '', link: 'https://info.yonnect.com/newsroom', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },
            { title: 'developers', icon: '', link: 'https://info.yonnect.com/developers', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },
            { title: 'Advertising', icon: '', link: 'https://info.yonnect.com/advertising', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },
            { title: 'Contact Us', icon: '', link: 'https://info.yonnect.com/contactus', description: 'Lorem ipsum dolor, sit amet consectetur adipisicing elit' },

        ],
        settings: { indicatorType: 'phone', mode: 'login', loginWithCode: false, passwordRequired: true },
        data: {},
        colors: {
            primaryColor: 'rgb(205, 100, 254)',
            secondaryColor: '#fe6481',
            // primaryColor: '#11998E',
            // secondaryColor: '#38EF7D',
            textColor: '#fff'
        },
        status: 0,
        pricingData: [
            {
                title: '{{lang}}Starter', key: 'starter', desc: '{{lang}}The essentials to get your team up and running',
                price: '$0', payment: '{{lang}}month', users: '{{lang}}Up to 50 users',
                buttons: [{ title: '{{lang}}Try for free', function: '', status: 0 }],
                options: {
                    list: [
                        '{{lang}}Unlimited chats & full context of message history',
                        '{{lang}}Custom and secured business email',
                        '{{lang}}Automatic language translation',
                        '{{lang}}100 GB storage',
                        '{{lang}}Up to 60 minutes meeting duration',
                    ]
                }
            },
            {
                title: '{{lang}}Pro', key: 'pro', desc: '{{lang}}Advanced tools to take your growing team to the next level',
                price: '$12', payment: '{{lang}}user per month', users: '{{lang}}Up to 500 users',
                buttons: [{ title: '{{lang}}Buy now', function: '', status: 2 }],
                options: {
                    title: '{{lang}}Everything in Starter, plus:', list: [
                        '{{lang}}Unlimited Wiki knowledge base',
                        '{{lang}}1 TB storage',
                        '{{lang}}500 meeting participants',
                        '{{lang}}24 hours meeting duration',
                        '{{lang}}Advanced permission controls',
                        '{{lang}}Advanced video conferencing capabilities',
                    ]
                }
            },
            {
                title: '{{lang}}Enterprise', key: 'enterprise', desc: '{{lang}}More features and data to transform your team',
                price: "{{lang}}Let's talk", users: '{{lang}}Unlimited users',
                buttons: [{ title: '{{lang}}Contact sales', function: '', status: 1 }],
                options: {
                    title: '{{lang}}Everything in Pro, plus:', list: [
                        '{{lang}}Large group collaboration (up to 50,000 users)',
                        '{{lang}}10 TB storage',
                        '{{lang}}Unlimited email storage',
                        '{{lang}}Single sign-on (SSO)',
                        '{{lang}}Advanced security',
                    ]
                }
            },
        ],

        headerConfig: { isPortal: true, doNotshowNotification: true }

    }


    componentDidMount() {
        // this.changeStage('username')

    }


    goToInitPage = () => {
        this.changeStage('init')
    }



    setStatus = (status, cb) => {
        this.setState({ status }, () => {
            if (cb) {
                cb()
            }
        })
    }




    setData = (data, cb) => {
        let newData = this.state.data ?? {}
        for (const [key, value] of Object.entries(data)) {
            newData[key] = value
        }
        this.setState({ data: newData }, () => {
            if (cb) { cb() }
        })
    }



    changeStage = (newStage, cb) => {
        if (this.stageManager) {
            this.stageManager.changeStage(newStage, cb)
        }
    }

    lastStage = () => {
        if (this.stageManager) {
            this.stageManager.lastStage()
        }
    }


    createHub = (cb) => {
        let data = this.state.data
        // console.log(data)

        // return
        HttpServices.request("createHub", data, (fetchResult, fetchError) => {
            // console.log(fetchResult)
            // console.log(fetchError)

            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.createFailed', description: fetchError.message })

                cb(false, fetchError.message)
                return
            }

            if (fetchResult.info) {
                
                cb(true)
                // console.log(fetchResult.info)
                // this.stageManager.nextStage()
                this.setState({ data: fetchResult.info }, () => {
                    if (fetchResult?.cart) {

                        store.dispatch(actions.setCart(fetchResult?.cart))
            
                    }
                    this.stageManager.changeStage('success')
                })

            }
            // this.props.history.push('/')

        })
    }


    visitHub = () => {
        this.props.changeWindow('hub', { path: [this.state.data?.username] })
    }

    // find settings applet slug
    // fetchHub = (username, cb) => {
    //     this.setState({ isLoadingPage: true })
    //     HttpServices.request('getHubByUsername', { username: username }, (fetchResult, fetchError, fetchStatus) => {

    //         // store.dispatch(actions.updateUsedRelation([fetchResult.relation]))

    //         this.setState({ isLoadingPage: false }, () => {
    //             if (fetchError) {
    //                 return
    //             }
    //             if (Array.isArray(fetchResult?.applets)) {
    //                 fetchResult.applets.forEach(el => {

    //                     if (Array.isArray(el?.applet?.features) && el?.applet?.features.length > 0 && el?.applet?.features[0] == 'Settings') {
    //                         this.setState({ settingsApplet: el.applet })
    //                         if (cb) {
    //                             cb(el.applet, fetchResult?.user?._id, el?.applet?.slug ?? 'settings')
    //                         }
    //                     }
    //                 });
    //             } else {
    //                 if (cb) {
    //                     cb(null, 'settings')
    //                 }
    //             }
    //         })
    //     })
    // }
    proceedToPayment = () => {
      
        // this.fetchHub(this.state.data?.username, (settingsApplet, hub, slug) => {
         
            // this.addToCart('add', this.state.data.license.quantity, this.state.cardItem, settingsApplet, hub, () => {
            this.props.changeWindow('applet', { path: [this.state.data?.username, 'settings', 'admin', 'licences', 'payment'] })
            // })
        // })
    }

    setCardItem = (item, cb) => {
        this.setState({ cardItem: item }, () => {
            if (cb) {
                cb()
            }
        })
    }
    // this.addToCart('add', 1, item, () => {})

    addToCart = (action, count, item, applet, targetHub, cb) => {

        if (!this.state.isLoading) {
            // let appletId = applet?._id
            let hub = targetHub

            let variants = item?.variants
            let additionals = item?.additionals
            let product = item?._id
            this.setState({ isLoading: true })

            // console.log('addToCart6', item)
            // return
            addToCard(applet, hub, product, action, count, variants, additionals, () => {
                this.setState({ isLoading: false }, () => {
                    if (cb) {
                        cb()
                    }
                })
            })
        }
    }

    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static'
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }

    showHeader = (prop, cb) => {
        this.setState({ show: prop }, () => {
            if (cb) {
                cb()
            }
        })
    }




    render() {
        let colors = this.state.colors ?? {}

        if (!colors?.textColor) {
            colors.textColor = '#fff'
        }

        let iconInvert = chooseFontColor(colors.textColor) == '#fff' ? true : false

        colors.iconInvert = iconInvert
        colors.background = `linear-gradient(90deg, ${colors.primaryColor}, ${colors.secondaryColor})`
        return (
            <div className="w-100 d-flex flex-column CreateHub  h-100 window-content-radius"  >

                <div style={{ position: 'relative', top: 0, display: this.state.show ? 'flex' : 'none' }}>
                    <Header ref={el => this.header = el} config={this.state.headerConfig} language={this.props.language} isDesktop={this.props.isDesktop} backbtn={this.state.showBackBtn} width={this.props.width} colors={colors} setHeader={this.setHeader} />
                </div>

                {/* <div className=' w-100 '> */}
                <StagesManager ref={el => this.stageManager = el} height={'0px'} className={'flex-1'} fast={true} >
                    <CHIntroduction stage={0} stageName={'init'} initData={this.state.data} setHeader={this.setHeader} showHeader={this.showHeader} colors={colors} language={this.props.settings?.language} setData={this.setData} width={this.props.width} />
                    <CHSelectType stage={1} stageName={'type'} initData={this.state.data} setHeader={this.setHeader} showHeader={this.showHeader} colors={colors} language={this.props.settings?.language} setData={this.setData} width={this.props.width} />
                    {/* <CHHubInfo stage={2} stageName={'hubInfo'} initData={this.state.data} setHeader={this.setHeader} showHeader={this.showHeader} colors={colors} language={this.props.settings?.language} setData={this.setData} width={this.props.width} /> */}
                    <CHInfo stage={2} stageName={'info'} initData={this.state.data} setHeader={this.setHeader} showHeader={this.showHeader} colors={colors} language={this.props.settings?.language} setData={this.setData} width={this.props.width} />
                    <CHUsername stage={3} stageName={'username'} initData={this.state.data} setHeader={this.setHeader} showHeader={this.showHeader} colors={colors} language={this.props.settings?.language} setData={this.setData} createHub={this.createHub} width={this.props.width} />
                    <CHPricing stage={4} stageName={'pricing'} initData={this.state.data} baseUrl={[...this.props.baseUrl]} setHeader={this.setHeader} showHeader={this.showHeader} colors={colors} language={this.props.settings?.language} setData={this.setData} width={this.props.width} pricingData={this.state.pricingData} setStatus={this.setStatus} setCardItem={this.setCardItem} />
                    {/* <CHPricingInfo stage={4} stageName={'pricingInfo'} initData={this.state.data} setHeader={this.setHeader} showHeader={this.showHeader} colors={colors} language={this.props.settings?.language} setData={this.setData} width={this.props.width} pricingData={this.state.pricingData} status={this.state.status} /> */}
                    <CHReview stage={5} stageName={'review'} initData={this.state.data} setHeader={this.setHeader} showHeader={this.showHeader} colors={colors} language={this.props.settings?.language} setData={this.setData} createHub={this.createHub} width={this.props.width} />

                    <CHSuccess stage={6} stageName={'success'} initData={this.state.data} setHeader={this.setHeader} showHeader={this.showHeader} colors={colors} language={this.props.settings?.language} setData={this.setData} visitHub={this.visitHub} width={this.props.width} proceedToPayment={this.proceedToPayment} />
                </StagesManager>
                {/* </div> */}


            </div>
        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CreateHub);
